
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOrderAbnormal, getHandleAbnormal } from "@/api/api-charge-service";
import i18n from "@/config/i18n";
@Component
export default class PiPileList extends Vue {
  formInline: objAny = {};
  defaultHandleFlag = 2;
  win: objAny = window;
  pileRecordTotalAmount = 0;
  platRecordTotalAmount = 0;
  private pileTableList: object[] = [];

  private delayedTableList: object[] = [];

  private platformTableList: object[] = [];
  private pileTableColumns: object[] = [
    {
      title: i18n.t("commonTableName.slotFlag"),
      key: "slotFlagDesc",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.chargeElect"),
      key: "electricity",
      minWidth: 80
    },
    {
      title: i18n.t("commonTableName.elecPrice"),
      key: "elecPrice",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.servicePrice"),
      key: "servicePrice",
      minWidth: 80
    }
  ];

  private delayTableColumns: object[] = [
    {
      title: i18n.t("commonTableName.delayMins"),
      key: "delayMins",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.delayFreeMins"),
      key: "delayFreeMins",
      minWidth: 80
    },
    {
      title: i18n.t("commonTableName.delayAmount"),
      key: "delayAmount",
      minWidth: 80
    }
  ];
  orderNo = "";
  async getDetail() {
    const ret = await getOrderAbnormal({ orderNo: this.formInline.orderNo });
    if (ret.status == this["$config"].apiStatus) {
      this.formInline = ret.data[0];
      this.defaultHandleFlag = this.formInline.defaultHandleFlag;

      const { pileRecord, platRecord } = this.formInline;
      // const { delayRecordInfoVo, pileRecord, platRecord } = this.formInline;
      if (this.formInline.pileRecord) {
        this.pileRecordTotalAmount = this.formInline.pileRecord.totalAmount;
      }

      if (this.formInline.platRecord) {
        this.platRecordTotalAmount = this.formInline.platRecord.totalAmount;
      }
      if (
        this.formInline.delayMins ||
        this.formInline.delayFreeMins ||
        this.formInline.delayAmount
      ) {
        this.delayedTableList.splice(0, this.delayedTableList.length, {
          delayMins: this.formInline.delayMins,
          delayFreeMins: this.formInline.delayFreeMins,
          delayAmount: this.formInline.delayAmount
        });
      }

      if (pileRecord && pileRecord.slotDetail) {
        this.pileTableList.splice(
          0,
          this.pileTableList.length,
          ...pileRecord.slotDetail
        );
      }
      if (platRecord && platRecord.slotDetail) {
        this.platformTableList.splice(
          0,
          this.platformTableList.length,
          ...platRecord.slotDetail
        );
      }
    }
  }

  cancelHandleSubmit() {
    this.win.history.go(-1);
  }

  async handleSubmit() {
    const data: objAny = {
      orderNo: this.orderNo,
      pilePkId: this.formInline.pilePkId,
      handleFlag: this.defaultHandleFlag,
      staPkId: this.formInline.staPkId
    };
    if (this.defaultHandleFlag == 3) {
      if (!this.formInline.paymentAmount)
        return this.$Message.error(
          i18n.t("please") + "" + i18n.t("abnormalOrder.amountPayable")
        );
      data.paymentAmount = this.formInline.paymentAmount;
    }
    const ret = await getHandleAbnormal(data);
    if (ret.status == this["$config"].apiStatus) {
      this.win.history.go(-1);
    }
  }
  created() {
    const localData = this["$common"].get("charge-order-list-item");

    if (localData) {
      this.formInline.orderNo = localData.orderNo;
      this.getDetail();
    }
  }

  mounted() {
    const localData = this["$common"].get("charge-order-list-item");
    if (localData) {
      this.formInline.orderNo = localData.orderNo;
      this.orderNo = localData.orderNo;
      this.getDetail();
    }
  }
}
